"use client";

import { createContext, useContext, useState, useId, useCallback } from "react";

import type { HeaderContextProps } from "./types/header.types";

export const HeaderContext = createContext<HeaderContextProps>({
  menuId: "",
  menuOpen: false,
  setMenuOpen: () => {},
  toggleMenu: () => {},
});

export const useHeaderContext = () => useContext(HeaderContext);

interface HeaderProviderProps {
  children: React.ReactNode;
  onMenuOpenChange?: (open: boolean) => void;
}

export const HeaderProvider: React.FC<HeaderProviderProps> = (props) => {
  const { children, onMenuOpenChange } = props;
  const [menuOpen, setMenuOpen] = useState(false);

  const menuId = useId();

  const toggleMenu = useCallback(() => {
    onMenuOpenChange?.(menuOpen);
    setMenuOpen(!menuOpen);
  }, [setMenuOpen, onMenuOpenChange, menuOpen]);

  const handleSetMenuOpen = useCallback(
    (open: boolean) => {
      onMenuOpenChange?.(open);
      setMenuOpen(open);
    },
    [setMenuOpen, onMenuOpenChange],
  );

  return (
    <HeaderContext.Provider value={{ menuId, menuOpen, setMenuOpen: handleSetMenuOpen, toggleMenu }}>
      {children}
    </HeaderContext.Provider>
  );
};
